import { NativeByUrlList } from "@/utils/common";
import { processOssImage } from "@/utils/image";
import { Dialog } from "@xp-design/mobile";
import { forwardRef, useImperativeHandle, useState } from "react";
import icon_close from "../../assets/icon_close.png";
import style from "./style.module.less";

export interface PrizeSuccessPopupData {
  /** 领奖成功弹窗图片 */
  successPopupImage: string;
  /** 跳转地址映射 */
  jumpUrlMap?: { [key: string]: string };
}

export interface PrizeSuccessPopupRef {
  open: (data: PrizeSuccessPopupData) => void;
  close: () => void;
}

interface PrizeSuccessPopupProps {
  onClose?: () => void;
}

const PrizeSuccessPopup = forwardRef<PrizeSuccessPopupRef, PrizeSuccessPopupProps>(
  ({ onClose }, ref) => {
    const [visible, setVisible] = useState(false);
    const [popupData, setPopupData] = useState<PrizeSuccessPopupData | null>(null);

    const handleOpen = (data: PrizeSuccessPopupData) => {
      if (!data?.successPopupImage) return;
      setPopupData(data);
      setVisible(true);
    };

    const handleClose = () => {
      setVisible(false);
      setPopupData(null);
      onClose?.();
    };

    const handleImageClick = () => {
      // 如果有跳转链接，先关闭弹窗再跳转
      if (popupData?.jumpUrlMap && Object.keys(popupData.jumpUrlMap).length > 0) {
        handleClose();
        NativeByUrlList(popupData.jumpUrlMap);
      }
    };

    useImperativeHandle(ref, () => ({
      open: handleOpen,
      close: handleClose,
    }));

    return (
      <Dialog
        visible={visible}
        onClose={handleClose}
        getContainer={null}
        closeOnMaskClick={true}
        bodyClassName={style.dialogBody}
        content={
          <div className={style.container}>
            <div className={style.imageWrapper}>
              <img
                className={style.popupImage}
                src={processOssImage(popupData?.successPopupImage || "")}
                alt="领奖成功"
                onClick={handleImageClick}
              />
              <img className={style.closeBtn} src={icon_close} alt="关闭" onClick={handleClose} />
            </div>
          </div>
        }
      />
    );
  }
);

export default PrizeSuccessPopup;
